import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { obtenerListaVacantes, aprobarSolicitudVacanteApi, declinarSolicitudVacanteApi } from "../api/contratacion/solicitudVacanteApi";
import { faEye, faMinusCircle, faCheckCircle, faTimesCircle, faPencil } from "@fortawesome/free-solid-svg-icons";
import { cerrarSessionModal, evaluarEstado, hideSideBarDesktop, momentFecha } from "../utils/funciones";
import { Celda, CeldaHeader } from "../cambios-contractuales/solicitudes-en-curso/useSolicitudesCurso";
import { BACKDROP, CUSTOM_CLASS, customStyles, objStyleCol, txtUnProblema } from "../utils/Constants";
import { mensajeCompleto, mensajeSimple, modalCargando } from "./ui/sweetAlerts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataContext } from "../contextData/contextData";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Spinner from "./ui/Spinner";
import Swal from "sweetalert2";
import "../css/app.css";

const ButtonsAcciones = ({ obj, accionRechazar, acccionVerVacante, accionAprobar, accionDeclinar }) => {
  const navigate = useNavigate();
  const idPerfil = localStorage.getItem("id_perfil");

  return (
    <div className="d-flex justify-content-start w-100">
      <button
        className="btn btnAccion rounded-3 btn-primary btn-sm"
        data-bs-toggle="tooltip"
        title="Ver solicitud"
        onClick={() => {
          acccionVerVacante(obj.id, obj.id_persona, obj);
        }}
      >
        <FontAwesomeIcon icon={faEye} title="Ver solicitud" />
      </button>

      {evaluarEstado(obj.id_estado_solicitud, idPerfil, "5") && (
        <button className="btn btnAccion btn-info btn-sm rounded-3" data-bs-toggle="tooltip" title="Devolución por correcciones" onClick={() => accionRechazar(obj.id)}>
          <FontAwesomeIcon icon={faMinusCircle} color="white" />
        </button>
      )}

      {evaluarEstado(obj.id_estado_solicitud, idPerfil, "2") && (
        <button disabled={obj.estado_actual === "Por enviar a SAP" || obj.estado_actual === "Enviado a SAP"} className="btn btnAccion rounded-3 btn-success btn-sm" data-bs-toggle="tooltip" title="Aprobar solicitud" onClick={() => accionAprobar(obj.id)}>
          <FontAwesomeIcon icon={faCheckCircle} />
        </button>
      )}

      {evaluarEstado(obj.id_estado_solicitud, idPerfil, "4") && (
        <button disabled={obj.estado_actual === "Por enviar a SAP" || obj.estado_actual === "Enviado a SAP"} className="btn btnAccion rounded-3 btn-danger btn-sm" data-bs-toggle="tooltip" title="Declinar solicitud" onClick={() => accionDeclinar(obj.id, obj)}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>
      )}

      {evaluarEstado(obj.id_estado_solicitud, idPerfil, "50") && (
        <button
          className="btn btnAccion btn-info btn-sm rounded-3"
          data-bs-toggle="tooltip"
          title="Editar contratacion"
          onClick={() => {
            navigate(`/editar-vacante/${obj.id}`, {
              state: { idSolicitud: obj.id, idPersonaSolicitud: obj.id_persona, solicitud: obj, id_estado_solicitud: obj.id_estado_solicitud },
            });
          }}
        >
          <FontAwesomeIcon icon={faPencil} color="white" />
        </button>
      )}
    </div>
  );
};

ButtonsAcciones.propTypes = {
  obj: PropTypes.object.isRequired,
  accionRechazar: PropTypes.func,
  acccionVerVacante: PropTypes.func.isRequired,
  accionAprobar: PropTypes.func.isRequired,
  accionDeclinar: PropTypes.func.isRequired,
};

ButtonsAcciones.defaultProps = {
  accionRechazar: () => {},
};

const ListadoVacantesScreen = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [pageTable, setPageTable] = useState(1);
  const { setNombreMenuu } = useContext(DataContext);

  useEffect(() => {
    setNombreMenuu("Solicitudes en progreso");
    fetchUsers(pageTable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEstadoActual = solicitud => {
    return solicitud.id_estado_solicitud === 8 && localStorage.getItem("id_perfil") === "3" ? "Evaluación Procesos & Remuneraciones" : solicitud.estado_actual;
  };

  const fetchUsers = async (page, newPerPage = 10) => {
    setLoading(true);
    const data = await obtenerListaVacantes(page, newPerPage);

    if (data.message?.status === "error" || data.msg) { cerrarSessionModal(); }

    setLoading(false);

    if (data.status === "info") {
      setData([]);
      mensajeSimple(data.status, data.menssage, 2000);
    }
    if (data.status === "success") {
      const dataTable = data.data.map(vacante => {
        return {
          id: vacante.id,
          nombre: vacante.nombre,
          identificacion: vacante.identificacion,
          nombre_vacante: vacante.nombre_vacante,
          fecha_ingreso: vacante.fecha_ingreso,
          id_estado_solicitud: vacante.id_estado_solicitud,
          estado_actual: getEstadoActual(vacante),
          responsable: vacante.responsable,
          observacion: vacante.observacion,
          unidad_organizativa: vacante.data_posicion?.MOES_NOMBRE_UNIDAD_ORGANIZATIV || "sin unidad",
          acciones: vacante,
        };
      });
      setData(dataTable);
      setTotalRows(data.paginacion.total);
    }
    hideSideBarDesktop();
  };

  const handlePageChange = page => {
    setPageTable(page);
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchUsers(page, newPerPage);
  };

  const nuevoColaborador = (row) => <Celda label={row.nombre} ancho="350px" />
  const instalacionComp = (row) => <Celda label={row.unidad_organizativa} ancho="230px" />
  const buttonAccionesComp = (row) => <ButtonsAcciones obj={row.acciones} accionRechazar={accionRechazar} acccionVerVacante={acccionVerVacante} accionAprobar={accionAprobar} accionDeclinar={accionDeclinar} />

  const columnas = [
    {
      name: <CeldaHeader label="ID" alineacion="center" />,
      selector: row => row.id,
      width: "70px",
      style: objStyleCol,
    },
    {
      name: "Nuevo colaborador",
      cell: row => nuevoColaborador(row),
      width: "350px",
    },
    {
      name: <CeldaHeader label="Rut" alineacion="center" />,
      sortable: false,
      selector: row => row.identificacion,
      style: objStyleCol,
      width: "110px",
    },
    {
      name: "Cargo",
      sortable: false,
      selector: row => row.nombre_vacante,
      width: "250px",
    },
    {
      name: "Instalación",
      cell: row => instalacionComp(row),
      width: "230px",
    },
    {
      name: "Fecha Ingreso",
      selector: row => momentFecha(row.fecha_ingreso),
      width: "110px",
      style: objStyleCol,
    },
    {
      name: "Estado actual",
      selector: row => (row.id_estado_solicitud === 16 ? `${row.estado_actual} por ${row.responsable}` : row.estado_actual),
      wrap: true,
      minWidth: "200px",
    },
    {
      name: "Observacion",
      selector: row => row.observacion,
      wrap: true,
      minWidth: "200px",
    },
    {
      name: "Acciones",
      sortable: false,
      cell: row => buttonAccionesComp(row),
      width: "150px",
      style: objStyleCol,
    },
  ];

  const getColumnas = () => {
    const perfil = localStorage.getItem("id_perfil");
    if (perfil === "4") {
      return columnas;
    } else {
      return columnas.filter((el, indx) => indx !== 6);
    }
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const accionAprobar = vacante => {

    Swal.fire({
      title: "¿Está seguro(a) de aprobar este ingreso de personal?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Aprobar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "red",
      showLoaderOnConfirm: true,
      reverseButtons: false,
      customClass: {
        container: "containerMensajeSimple",
        title: "titleMensajeSimple",
        text: "txtLabellInput",
        popup: `popUpSweetCancelarEnviar`,
        confirmButton: "btnCopec me-4",
        cancelButton: "btnAtras",
      },
      buttonsStyling: false,
      backdrop: "#395c9d5c left top no-repeat",
      preConfirm: () => {
        return aprobarSolicitudVacanteApi(vacante)
          .then(response => {
            if (response.status !== "success") {
              throw new Error("No fue posible ingresar la solicitud");
            }
            return response;
          })
          .catch(error => {
            Swal.showValidationMessage(`No fue posible ingresar la solicitud`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(result => {
      if (result.isConfirmed) {
        if (result.value.status === "success") {
          mensajeSimple("success", "Solicitud Aceptada!");
          fetchUsers(pageTable);
        } else {
          Swal.fire("Existe un error al aprobar la vacante!", "", "info");
        }
      }
    });
  };

  const accionDeclinar = async (idSolicitud, objSolicitud) => {
    const { value: text } = await Swal.fire({
      input: "textarea",
      title: "Motivo para declinar",
      inputPlaceholder: "Escribe tu motivo...",
      inputAttributes: { "aria-label": "Type your message here" },
      reverseButtons: false,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Continuar",
      customClass: CUSTOM_CLASS,
      backdrop: BACKDROP,
      showCancelButton: true,
      allowOutsideClick: false,
      buttonsStyling: false,
    });

    if (!text?.trim()) {
      return;
    }

    const result = await Swal.fire({
      title: "¿Estás seguro de declinar la vacante?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Declinar",
      cancelButtonText: "Cancelar",
      customClass: CUSTOM_CLASS,
      backdrop: BACKDROP,
      buttonsStyling: false,
      reverseButtons: false,
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      console.log("Declinar solicitud con ID: ", idSolicitud);
      modalCargando("Declinando solicitud y liberando posición");
      const body = {
        observaciones: text.trim(),
        rechazo: true,
        rechazo_temporal: false,
      };

      try {
        const response = await declinarSolicitudVacanteApi(idSolicitud, body);

        if (response.status === "error") {
          mensajeSimple("error", response.message, 5000);
        } else if (response.status === "info") {
          mensajeSimple("info", response.message, 5000);
        } else if (response.status === "success") {
          mensajeSimple("success", response.message);
          fetchUsers(pageTable);
        }
      } catch (error) {
        console.error("Error declinando solicitud de vacante:", error);
        mensajeSimple("error", "Ocurrió un error al momento de declinar la solicitud.");
      }
    }
  };

  const accionRechazar = async idSolicitud => {
    const { value: text } = await Swal.fire({
      input: "textarea",
      title: "Motivo de devolución",
      inputPlaceholder: "Motivo...",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      showCancelButton: true,
      confirmButtonText: "Devolver",
      cancelButtonText: `Cancelar`,
      customClass: {
        container: "containerMensajeSimple",
        title: "titleMensajeSimple",
        text: "txtLabellInput",
        popup: `popUpSweetCancelarEnviar`,
        confirmButton: "btnSweetSolo me-4",
        cancelButton: "btnAtras",
      },
      buttonsStyling: false,
    });

    if (text) {
      Swal.fire({
        title: "¿Está seguro que desea devolver temporalmente?",
        icon: "warning",
        showCancelButton: true,
        customClass: CUSTOM_CLASS,
        confirmButtonText: "Devolver",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "red",
        showLoaderOnConfirm: true,
        buttonsStyling: false,
        preConfirm: () => {
          const body = {
            observaciones: text,
            rechazo: false,
            rechazo_temporal: true,
          };

          return declinarSolicitudVacanteApi(idSolicitud, body)
            .then(response => {
              if (response.status !== "success") {
                throw new Error("No fue posible ingresar la solicitud");
              }
              return response;
            })
            .catch(error => {
              mensajeSimple("info", txtUnProblema, 2000);
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed) {
          if (result.value.status === "success") {
            mensajeCompleto("success", "¡Solicitud Rechazada Parcialmente!", `Motivo: ${text}`, 4000);
            setTimeout(() => {
              fetchUsers(pageTable);
            }, 3700);
          } else {
            mensajeSimple("info", txtUnProblema, 2000);
          }
        }
      });
    }
  };
  const acccionVerVacante = async (idSolicitud, idPersonaSolicitud, solicitud) => {
    return navigate(`/vacante/${idSolicitud}`, { state: { idSolicitud, idPersonaSolicitud, solicitud, editable: true } });
  };

  return (
    <div className="row">
      <div className="col-sm-12 ">
        <div className="card">
          <div className="card-header bgArcopime h5 py-1">Solicitudes en progreso</div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body contenedorTabla">
              {data.length > 0 ? (
                <DataTable
                  title={false}
                  responsive={true}
                  columns={getColumnas()}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationDefaultPage={pageTable}
                  paginationPerPage={perPage}
                  customStyles={customStyles}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationComponentOptions={paginationComponentOptions}
                  dense
                  fixedHeaderScrollHeight="440px"
                />
              ) : (
                <p className="h5 text-center my-3 titleMensajeSimple">No se encontraron registros</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListadoVacantesScreen;
